var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCopyClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Copy to clipboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 0.414311 0 0 0 0 0.380392 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/icoCopyClipboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/icoTextExperiment-Copy-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-41-+-Fill-42"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0015,16.0005 L6.0005,16.0005 L6.0005,2.0005 L12.0005,2.0005 L12.0005,6.0005 L16.0005,6.0005 L16.0015,16.0005 Z M13.4145,0.0005 L6.0005,0.0005 C4.8975,0.0005 4.0005,0.8985 4.0005,2.0005 L4.0005,16.0005 C4.0005,17.1025 4.8975,18.0005 6.0005,18.0005 L16.0005,18.0005 C17.1035,18.0005 18.0005,17.1025 18.0005,16.0005 L18.0005,4.5865 L13.4145,0.0005 Z",
    id: "Fill-41",
    fill: "#272c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,4.0005 L0,4.0005 L0,20.0005 C0,21.1025 0.897,22.0005 2,22.0005 L14,22.0005 L14,20.0005 L2,20.0005 L2,4.0005 Z",
    id: "Fill-42",
    fill: "#272c4d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCopyClipboard);
export default __webpack_public_path__ + "static/media/ico-copy-clipboard.2ed44886c2271101f924fa9b03d5b353.svg";
export { ForwardRef as ReactComponent };